import { api } from '@/lib/api';
import { ApiError } from '@/lib/api-errors';

const PERSISTED_OCCURRENCE_ID_RE =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

export const isPersistedOccurrenceId = (id: string | null | undefined): id is string =>
  typeof id === 'string' &&
  !id.startsWith('schedule:') &&
  !id.startsWith('pending:') &&
  PERSISTED_OCCURRENCE_ID_RE.test(id);

export const findOccurrenceForProgramDate = async (input: {
  programId: string;
  occurrenceDate: string;
}): Promise<string | null> => {
  const params = new URLSearchParams({
    programId: input.programId,
    fromDate: input.occurrenceDate,
    toDate: input.occurrenceDate,
    pageSize: '1',
  });
  const result = await api.get<{ data: Array<{ id: string }> }>(`/occurrences?${params}`);
  return result.data[0]?.id ?? null;
};

/** Returns a persisted occurrence id for a program date, creating one when needed. */
export const ensureProgramOccurrenceId = async (input: {
  programId: string;
  occurrenceDate: string;
}): Promise<string> => {
  const existing = await findOccurrenceForProgramDate(input);
  if (existing) return existing;

  try {
    const created = await api.post<{ id: string }>(
      `/programs/${input.programId}/occurrences`,
      { occurrenceDate: input.occurrenceDate },
    );
    return created.id;
  } catch (err) {
    if (!(err instanceof ApiError) || err.code !== 'OCCURRENCE_DATE_TAKEN') throw err;
    const resolved = await findOccurrenceForProgramDate(input);
    if (!resolved) throw err;
    return resolved;
  }
};
